import React from 'react';
import { UserLayout } from '../../components/Layout/UserLayout';
import { LayoutDashboard, Users, SproutIcon, DollarSign, TrendingUp, AlertCircle, ArrowUpRight, ArrowDownRight, FileText } from 'lucide-react';
export const AdminDashboardPage = () => {
  // Sample data for admin dashboard
  const stats = [{
    title: 'Total Projects',
    value: '47',
    change: '+12%',
    isPositive: true,
    icon: <SproutIcon size={20} className="text-green-600" data-id="element-552" />
  }, {
    title: 'Total Users',
    value: '328',
    change: '+8%',
    isPositive: true,
    icon: <Users size={20} className="text-blue-600" data-id="element-553" />
  }, {
    title: 'Total Investments',
    value: 'RM 2.4M',
    change: '+15%',
    isPositive: true,
    icon: <DollarSign size={20} className="text-amber-600" data-id="element-554" />
  }, {
    title: 'Success Rate',
    value: '92%',
    change: '+3%',
    isPositive: true,
    icon: <TrendingUp size={20} className="text-purple-600" data-id="element-555" />
  }];
  const recentProjects = [{
    id: 1,
    name: 'Sustainable Rice Farming',
    farmer: 'Ahmad Ismail',
    location: 'Kedah',
    amount: 'RM 320,000',
    status: 'Active'
  }, {
    id: 2,
    name: 'Vertical Farming Technology',
    farmer: 'Mei Lin',
    location: 'Selangor',
    amount: 'RM 550,000',
    status: 'Active'
  }, {
    id: 3,
    name: 'Organic Durian Farm',
    farmer: 'Kamal Adnan',
    location: 'Pahang',
    amount: 'RM 490,000',
    status: 'Completed'
  }, {
    id: 4,
    name: 'Aquaculture System',
    farmer: 'Raj Kumar',
    location: 'Selangor',
    amount: 'RM 420,000',
    status: 'Active'
  }];
  const pendingActions = [{
    id: 1,
    title: 'Project Approval',
    description: '3 new projects waiting for approval',
    priority: 'High'
  }, {
    id: 2,
    title: 'Verification Request',
    description: '5 farmers awaiting verification',
    priority: 'Medium'
  }, {
    id: 3,
    title: 'Repayment Review',
    description: '2 repayment schedules need review',
    priority: 'High'
  }, {
    id: 4,
    title: 'Support Tickets',
    description: '8 open support tickets',
    priority: 'Medium'
  }];
  return <UserLayout requiredUserType="admin" data-id="element-556">
      <div className="mb-6" data-id="element-557">
        <h1 className="text-2xl font-bold text-soil-brown flex items-center" data-id="element-558">
          <LayoutDashboard size={24} className="mr-2" data-id="element-559" />
          Admin Dashboard
        </h1>
        <p className="text-gray-600" data-id="element-560">
          Welcome to the GrowConnect admin dashboard
        </p>
      </div>
      {/* Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-561">
        {stats.map((stat, index) => <div key={index} className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-leaf-green" data-id="element-562">
            <div className="flex justify-between items-start" data-id="element-563">
              <div data-id="element-564">
                <p className="text-sm text-gray-500" data-id="element-565">{stat.title}</p>
                <h3 className="text-2xl font-bold mt-1" data-id="element-566">{stat.value}</h3>
                <div className={`flex items-center mt-1 text-sm ${stat.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-567">
                  {stat.isPositive ? <ArrowUpRight size={14} className="mr-1" data-id="element-568" /> : <ArrowDownRight size={14} className="mr-1" data-id="element-569" />}
                  <span data-id="element-570">{stat.change} from last month</span>
                </div>
              </div>
              <div className="p-2 bg-gray-100 rounded-full" data-id="element-571">{stat.icon}</div>
            </div>
          </div>)}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-572">
        {/* Recent Projects */}
        <div className="lg:col-span-2" data-id="element-573">
          <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-574">
            <div className="flex justify-between items-center mb-4" data-id="element-575">
              <h2 className="text-lg font-semibold" data-id="element-576">Recent Projects</h2>
              <button className="text-sm text-leaf-green hover:underline" data-id="element-577">
                View all
              </button>
            </div>
            <div className="overflow-x-auto" data-id="element-578">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-579">
                <thead data-id="element-580">
                  <tr data-id="element-581">
                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-582">
                      Project
                    </th>
                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-583">
                      Farmer
                    </th>
                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-584">
                      Location
                    </th>
                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-585">
                      Amount
                    </th>
                    <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-586">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-587">
                  {recentProjects.map(project => <tr key={project.id} className="hover:bg-gray-50" data-id="element-588">
                      <td className="px-3 py-4 whitespace-nowrap" data-id="element-589">
                        <div className="flex items-center" data-id="element-590">
                          <div className="flex-shrink-0 h-8 w-8 bg-leaf-green/10 rounded-full flex items-center justify-center" data-id="element-591">
                            <SproutIcon size={16} className="text-leaf-green" data-id="element-592" />
                          </div>
                          <div className="ml-3" data-id="element-593">
                            <div className="text-sm font-medium text-gray-900" data-id="element-594">
                              {project.name}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-595">
                        {project.farmer}
                      </td>
                      <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-596">
                        {project.location}
                      </td>
                      <td className="px-3 py-4 whitespace-nowrap text-sm font-medium" data-id="element-597">
                        {project.amount}
                      </td>
                      <td className="px-3 py-4 whitespace-nowrap" data-id="element-598">
                        <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${project.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-599">
                          {project.status}
                        </span>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* Pending Actions */}
        <div className="lg:col-span-1" data-id="element-600">
          <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-601">
            <div className="flex justify-between items-center mb-4" data-id="element-602">
              <h2 className="text-lg font-semibold" data-id="element-603">Pending Actions</h2>
              <button className="text-sm text-leaf-green hover:underline" data-id="element-604">
                View all
              </button>
            </div>
            <div className="space-y-4" data-id="element-605">
              {pendingActions.map(action => <div key={action.id} className="border-l-4 border-amber-500 bg-amber-50 p-3 rounded-r-lg" data-id="element-606">
                  <div className="flex items-start" data-id="element-607">
                    <AlertCircle size={20} className="text-amber-500 mr-2 mt-0.5" data-id="element-608" />
                    <div data-id="element-609">
                      <h3 className="text-sm font-medium flex items-center" data-id="element-610">
                        {action.title}
                        <span className={`ml-2 px-2 py-0.5 text-xs rounded-full ${action.priority === 'High' ? 'bg-red-100 text-red-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-611">
                          {action.priority}
                        </span>
                      </h3>
                      <p className="text-sm text-gray-600 mt-1" data-id="element-612">
                        {action.description}
                      </p>
                      <button className="text-xs text-leaf-green hover:underline mt-2" data-id="element-613">
                        Take action
                      </button>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Quick Links */}
          <div className="bg-white rounded-lg shadow-sm p-4 mt-6" data-id="element-614">
            <h2 className="text-lg font-semibold mb-4" data-id="element-615">Quick Links</h2>
            <div className="grid grid-cols-2 gap-3" data-id="element-616">
              <button className="p-3 bg-leaf-green/10 rounded-lg text-sm text-leaf-green flex items-center justify-center" data-id="element-617">
                <FileText size={16} className="mr-2" data-id="element-618" />
                Generate Report
              </button>
              <button className="p-3 bg-leaf-green/10 rounded-lg text-sm text-leaf-green flex items-center justify-center" data-id="element-619">
                <Users size={16} className="mr-2" data-id="element-620" />
                User Management
              </button>
              <button className="p-3 bg-leaf-green/10 rounded-lg text-sm text-leaf-green flex items-center justify-center" data-id="element-621">
                <SproutIcon size={16} className="mr-2" data-id="element-622" />
                Add Project
              </button>
              <button className="p-3 bg-leaf-green/10 rounded-lg text-sm text-leaf-green flex items-center justify-center" data-id="element-623">
                <DollarSign size={16} className="mr-2" data-id="element-624" />
                Finance
              </button>
            </div>
          </div>
        </div>
      </div>
    </UserLayout>;
};